import { PlaceholderEmptyState } from 'common/components/PlaceholderEmptyState';
import useTranslation from 'common/hooks/useTranslation';
import React from 'react';

import TipTapEditorImproved from './TipTapEditorImproved';

export const DescriptionTab = ({ offerDescription }) => {
  const { t } = useTranslation('offers\\details');

  return offerDescription ? (
    <div className='grid grid-cols-1 gap-4'>
      <div className='w-2/3 pt-4'>
        <TipTapEditorImproved content={offerDescription} isEditable={false} />
      </div>
    </div>
  ) : (
    <PlaceholderEmptyState className='pt-4' text={t('noDescription')} />
  );
};
